import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'

export function RequestAgentCallbackWarningModal() {
  const intl = useIntl()
  return (
    <ModalBase>
      <form>
        <ModalHeader title={intl.formatMessage({
          id: 'S94SnfbCdOmMESZKCuVc',
          defaultMessage: 'Callback request error',
          description: 'Title for callback request warning modal when user already has a pending callback',
        })}
        />
        <ModalBody>
          <ModalContent>
            <VerticalSpacer gap={20}>
              <Group direction="vertical" gap={20}>
                <BodyTextBlock variant="large">
                  {intl.formatMessage({
                    id: 'rXz2hhJuWr9hjKCyUjm_',
                    defaultMessage: 'You have already requested a callback. We’ll get back to you as soon as we can.',
                    description: 'Warning message when user has already scheduled a callback',
                  })}
                </BodyTextBlock>
              </Group>
            </VerticalSpacer>
          </ModalContent>
        </ModalBody>
        <ModalFooter primaryActionProps={{
          children: intl.formatMessage({
            id: '0EPxPE2sjYYL1YnqXBB6',
            defaultMessage: 'Close',
            description: 'Close/dismiss button for callback warning modal in a modal dialog',
          }),
        }}
        />
      </form>
    </ModalBase>
  )
}
